import { FieldNumberOutlined, UserOutlined } from '@ant-design/icons';
import { Form, Input } from "antd";
import { Domain } from "../../apis/mgmt/api";
import { DataForm } from "../common/DataForm";
import { DataViewProps } from "../common/DataView";
import { PermissionSectionList, usePermissionListByDomain } from "../permission/PermissionList";
import { PlatformDomainSectionList, usePlatformDomainListByDomain } from '../platformdomain/PlatformDomainList';


export const DomainForm = function (
    props: DataViewProps<Domain>
) {

    const domainId = props.data?.id;
    
    const permissionList = usePermissionListByDomain({ domainId })['listProps'];
    const permissionDefault = { role: { domain: props.data }  };

    const platformDomainList = usePlatformDomainListByDomain({ domainId })['listProps'];
    const platformDomainDefault= { domain: props.data };


    return (<>
        <DataForm {...props}>
            {/* id */}
            <Form.Item
                className="input"
                name="id"
            >
                <Input prefix={<FieldNumberOutlined className="site-form-item-icon" />} placeholder="ID" disabled={true} />
            </Form.Item>

            {/* name */}
            <Form.Item
                className="input"
                name="slug"
                rules={[{ required: true, message: '¡Please input the Slug!' }]}
            >
                <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Slug" />
            </Form.Item>

        </DataForm>

        <PermissionSectionList listProps={permissionList} defaultAddItemData={permissionDefault} />

        <PlatformDomainSectionList listProps={platformDomainList} defaultAddItemData={platformDomainDefault} />

    </>);

};
